import { render, staticRenderFns } from "./stenova.vue?vue&type=template&id=3dfd389e"
import script from "./stenova.vue?vue&type=script&lang=js"
export * from "./stenova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports